import './mission.css'

export default function Mission(){
    return (
        <div className="main-mission">
            <div className='mission-div'>
                <div className='mission-heading'>
                    <h3>Sarte's Mission</h3>
                    <h1>Driving excellence through <br />vision and precision.</h1>
                    
                    <p>Excellence isn’t just our goal — it’s our way of working. With a clear vision that inspires progress and a commitment to precision that perfects every detail, we deliver solutions that truly stand apart. At Sarte Groups, we turn ambition into achievement.</p>
                </div>

                <div className='mission-heading'>
                    <h3>Sarte's view</h3>
                    <h1>Vision that Commands</h1>
                    
                    <p>Our vision is more than foresight — it’s leadership. By anticipating change and setting bold directions, we command opportunities rather than chase them. At Sarte Groups, vision shapes every decision and defines every success.</p>
                </div>

                <div className='mission-heading'>
                    <h3>The Sarte Edge</h3>
                    <h1>Innovation That Commands<br /> Respect</h1>
                    
                    <p>We believe innovation should do more than impress — it should earn trust. At Sarte Groups, our ideas are crafted with purpose, built on expertise, and refined with integrity, creating solutions that inspire confidence and command respect.</p>
                </div>
            </div>
        </div>
    )
}